module.exports = __webpack_public_path__ + "static/2-2fdfabe87007fd6026b25ae3efcb24e5.jpg";